if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // 1. Validate ô input properties[Custom Name] hoặc properties[Custom Name 1] nếu có trên form
        const customNameInput = this.form.querySelector('input[name="properties[Custom Name]"], input[name="properties[Custom Name 1]"], input[name^="properties[Custom Name"]');
        if (customNameInput && customNameInput.required !== false && !customNameInput.disabled) {
          const val = customNameInput.value ? customNameInput.value.trim() : '';
          if (!val) {
            customNameInput.focus();
            if (typeof customNameInput.reportValidity === 'function') {
              customNameInput.reportValidity();
            }
            this.handleErrorMessage('Please enter a custom name before adding to cart.');
            return;
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Đảm bảo các input có form="formId" ngoài thẻ form cũng được đưa vào FormData
        if (this.form.id) {
          document.querySelectorAll(`[form="${this.form.id}"][name^="properties["]`).forEach((inp) => {
            if (inp.name && inp.value && !formData.has(inp.name)) {
              formData.append(inp.name, inp.value.trim());
            }
          });
        }

        if (!this.cart || typeof this.cart.getSectionsToRender !== 'function') {
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        }

        const sectionsToRender = (this.cart && typeof this.cart.getSectionsToRender === 'function')
          ? this.cart.getSectionsToRender().map((section) => section.id)
          : [];

        if (sectionsToRender.length > 0) {
          formData.append('sections', sectionsToRender.join(','));
          formData.append('sections_url', window.location.pathname);
        }
        if (this.cart && typeof this.cart.setActiveElement === 'function') {
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const cartAddUrl = (window.routes && window.routes.cart_add_url) || (window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js');

        fetch(cartAddUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }
            this.error = false;

            const cartFallbackUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (this.cart && typeof this.cart.renderContents === 'function') {
                      this.cart.renderContents(response);
                    } else if (this.cart && typeof this.cart.open === 'function') {
                      this.cart.open();
                    } else {
                      window.location.href = cartFallbackUrl;
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (this.cart && typeof this.cart.renderContents === 'function') {
                this.cart.renderContents(response);
              } else if (this.cart && typeof this.cart.open === 'function') {
                this.cart.open();
              } else {
                window.location.href = cartFallbackUrl;
              }
            }
          })
          .catch((e) => {
            console.error(e);
            window.location.href = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
              const stepper = this.querySelector('card-qty-stepper');
              if (stepper && typeof stepper.reset === 'function') {
                stepper.reset();
              }
            }
            this.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          const template = this.submitButton.dataset.btnTemplate;
          if (template) {
            this.submitButtonText.innerHTML = text || template;
          } else {
            this.submitButtonText.textContent = text ?? window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
